


























import { Component, Vue } from "vue-property-decorator";
import contactUs from "@/jsbridge/service/contact_us";

@Component({
  components: {}
})
export default class AndroidMoreEntrance extends Vue {
  get entranceList() {
    return [
      {
        icon: require("@/assets/icons-file/more/cg_tab5_order@3x.png"),
        text: "Orders",
        clickFunction: () => {
          this.$router.push({
            name: "Orders",
            query: {
              routerTransition: "forward"
            }
          });
        }
      },
      {
        icon: require("@/assets/icons-file/more/cg_tab5_shop@3x.png"),
        text: "Get Coins",
        clickFunction: () => {
          this.$router.push({
            name: "CoinStore",
            query: {
              routerTransition: "up"
            }
          });
        }
      },
      {
        icon: require("@/assets/icons-file/more/ico_tab5_contact@3x.png"),
        text: "Contact Us",
        clickFunction: () => {
          contactUs();
        }
      }
    ];
  }
  private clickItem(fun: any) {
    fun && fun();
  }
}
